import { ContactCompanies } from './orionContactCompany';
export class Gdpr {
  contactId: number;
  firstName: string;
  middleName: string;
  lastName: string;
  isResearched: boolean;
  responseMessage: string;
  gdprStatus: string;
  contactCompanies: ContactCompanies[];
}
type EventFlag = 'D' | 'F' | 'S' | 'E' | 'R' | 'C' | 'A' | 'B' | 'T' | 'I' | 'P';
interface EventDetails {
  eventType: string;
  description: string;
  createdDateTime: string;
  eventFlag: EventFlag;
}
export class PeopleData {
  id = '';
  source = '';
  firstName = '';
  middleName = '';
  lastName = '';
  companyName = '';
  jobFunction = '';
  businessEmail = '';
  businessPhone = '';
  businessFax = '';
  primaryAddress = '';
  mailingAddress = '';
  hashCode = '';
  isHashCodeExpired = false;
  emailSentDateTime = '';
  isDuplicate = false;
  isDeleted = false;
  actionFlag: EventFlag = 'F';
  countryCode = '';
  eventDetails: Array<EventDetails> = [];
  lastModifiedDateTime = '';
  createdDateTime = '';
}
